import { useMemo } from "react";
import { getDynamicStyle } from "../styles/helpers";
var useDynamicStyle = function useDynamicStyle(gradientColor, initialHeight) {
  return useMemo(function () {
    return getDynamicStyle(gradientColor, initialHeight);
  }, [gradientColor, initialHeight]);
};
export default useDynamicStyle;